module.exports = __webpack_public_path__ + "img/wanderSaneGlobe.14f9e0fe.svg";